import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const GET_HOME_PREVIOUS_BASKET = 'GET_HOME_PREVIOUS_BASKET';
export const GET_HOME_PREVIOUS_BASKET_REQUEST = 'GET_HOME_PREVIOUS_BASKET_REQUEST';
export const GET_HOME_PREVIOUS_BASKET_RESPONSE = 'GET_HOME_PREVIOUS_BASKET_RESPONSE';
export const GET_HOME_PREVIOUS_BASKET_ERROR = 'GET_HOME_PREVIOUS_BASKET_ERROR';

export const getHomepagePreviousBaskets = () =>
  makeApiRequest({
    requestType: GET_HOME_PREVIOUS_BASKET,
    method: RequestService.getHomePreviousBaskets,
  });
